module.exports = __webpack_public_path__ + "img/dashboard_top_title_en.8afd6dc9.png";